module.exports = {
  "country": "DE",
  "artist": "Katja  Ebstein",
  "song": "Theater",
  "year": "1980",
  "place": "2",
  "spotify": "0AwEdicbbKKAoB7ft7pJWI"
};